export default __webpack_public_path__ + "static/media/feature4.ca04fbc0.svg";